export default {"src":"/_next/static/media/FAM_Logo_White.ae9826a9.svg","height":10000,"width":10000,"blurWidth":0,"blurHeight":0};